import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import { FROM_0_TO_999_W1_DECIMAL_REGEX, FIVE_NUMBERS_REGEX } from '#utils/string/regex';
import Checkbox from '#components/general/Checkbox';
import { MEASURE_TYPES } from '#components/general/Input/components/Measure/constants';
import Input from '#components/general/Input';

import { DIPS_ISR_FIELDS, SPIRIT_SUBSTEPS_IDS } from './constants';
import styles from './styles.module.scss';

export const getDipISRFields = ({ values, errors }) => {
  const getDipISRValues = getSubStepValues(SPIRIT_SUBSTEPS_IDS.DIP_ISR, values, errors);
  return [
    {
      ...getDipISRValues(DIPS_ISR_FIELDS.DIP_ISR_HEIGHT),
      Component: Input,
      needsRegex: true,
      customRegex: FROM_0_TO_999_W1_DECIMAL_REGEX,
      measure: MEASURE_TYPES.LENGTH
    },
    {
      ...getDipISRValues(DIPS_ISR_FIELDS.DIP_ISR_VOLUME),
      Component: Input,
      needsRegex: true,
      customRegex: FIVE_NUMBERS_REGEX,
      measure: MEASURE_TYPES.LITRES
    },
    {
      key: 'ISRSubtitle',
      Component: () => (
        <div className={styles.isrSubtitle}>{t(`${SPIRIT_SUBSTEPS_IDS.DIP_ISR}:ISRSubtitle`)}</div>
      ),
      noMargin: true
    },
    {
      ...getDipISRValues(DIPS_ISR_FIELDS.ISR_TRANSFERRED),
      Component: Checkbox
    },
    {
      ...getDipISRValues(DIPS_ISR_FIELDS.ISR_OPERATOR),
      Component: Input
    }
  ];
};
